export default __webpack_public_path__ + "static/media/hasWasher.6d607b9c.png";